class Notification {

    /**
     * @param {HTMLElement} element
     * @param {Object} options
     */
    constructor(element, options) {
        this._element = element;
        this._options = options;

        this._elements = {
            description: this._element.querySelector(
                '.notification__description'
            ),
            close: this._element.querySelector('.notification__close')
        };

        this._addEventListeners();
    }

    /**
     * Set all the event listeners for the notification
     */
    _addEventListeners() {
        // The close element can be hidden due to notification settings
        // So we check if it exists first
        if (this._elements.close) {
            this._elements.close.addEventListener('click', () => this._hideNotification());
        }
    }

    /**
     * Hide the notification by adding the modifier class
     */
    _hideNotification() {
        this._element.classList.add('notification--hidden');
    }
}

// Exports
export default Notification;
